import { Pencil, Trash2, Eye } from "lucide-react";
import styles from "./ActionButtons.module.css";

const ActionButtons = ({
  row,
  onEdit,
  onDelete,
  onView,

  showEdit = true,
  showDelete = true,
  showView = true,

  deleteLabel = "Delete",
  canDelete = true,
  onRequestDelete,
  disabled = false,
}) => {
  return (
    <div className={styles.wrap}>

      {/* Edit */}
      {showEdit && (
        <button
          type="button"
          onClick={() => onEdit?.(row)}
          disabled={disabled}
          title="Edit"
          className={[styles.btn, styles.edit].join(" ")}
        >
          <Pencil className={styles.iconEdit} />
        </button>
      )}

      {/* Delete / Request Deletion */}
      {showDelete && (
        <button
          type="button"
          onClick={() => {
            if (!canDelete && onRequestDelete) {
              onRequestDelete(row);
            } else {
              onDelete?.(row);
            }
          }}
          disabled={disabled}
          title={!canDelete ? "Request to Delete" : deleteLabel}
          className={[
            styles.btn,
            styles.delete,
            !canDelete ? styles.requestDelete : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <Trash2 className={styles.iconDelete} />
        </button>
      )}

      {/* View */}
      {showView && (
        <button
          onClick={() => onView?.(row)}
          disabled={disabled}
          title="View"
          className={[styles.btn, styles.view].join(" ")}
        >
          <Eye className={styles.iconView} />
        </button>
      )}

    </div>
  );
};

export default ActionButtons;
